<bp-alert [errors]="(identityFacade.error$ | async)?.messages" type="danger"> </bp-alert>

<div *ngIf="identityFacade.pending$ | async" class="flex-justify-content-center flex-align-items-center h-100">
	<bp-spinning-logo></bp-spinning-logo>
</div>
